import { BoxProps } from 'UIKit/Box/types'
import Button from 'UIKit/Button'
import { UserBonus } from 'config/types/bonus/userBonus'
import useModal from 'hooks/useModal'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import BonusDetailsModal from 'views/BonusCenter/components/BonusDetailsModal'

interface BonusActionProps {
  bonus: UserBonus
}

const BonusAction: React.FC<BonusActionProps & BoxProps> = ({ bonus, ...props }) => {
  const [onPresentBonusDetailModal] = useModal(BonusDetailsModal)

  return (
    <StyledButton onClick={() => (bonus ? onPresentBonusDetailModal({ bonus }) : null)} {...props}>
      <Trans>Bonus Details</Trans>
    </StyledButton>
  )
}

export const StyledButton = styled(Button)`
  background: rgba(255, 255, 255, 0.12);
  height: 40px;
  border-radius: 8px;
  white-space: nowrap;
  box-sizing: border-box;
  padding: 0px 8px !important;
  flex: 1 1;
  font-size: 14px;
  font-weight: bold;

  &:disabled {
    color: ${({ theme }) => theme.colors.textSubtle};
  }
`

export default BonusAction
